import { sendGTMEvent as sendGTMEventNext } from '@next/third-parties/google';
import { SHA256 } from 'crypto-js';

import type { GTMEvents } from './gtmEvents';

interface Props {
  event: GTMEvents;
  data?: {
    [key: string]: unknown;
  };
  email?: string;
  phone_number?: string;
}

export default function sendGTMEvent({ event, data, email, phone_number }: Props) {
  if (!event) {
    return;
  }

  const hashedEmail = email ? SHA256(email).toString() : undefined;
  const hashedPhoneNumber = phone_number ? SHA256(phone_number).toString() : undefined;

  const finalData = {
    value: 1,
    currency: 'EUR',
    ...data,
    email: hashedEmail,
    phone_number: hashedPhoneNumber,
  };

  // eslint-disable-next-line no-console
  // console.log('[GTM]', event, finalData);

  sendGTMEventNext({
    event,
    ...finalData,
  });
}
